import endpoints from "../config/endpoints";
import api from "../config/axios";

export const AddUserAddress = async (addressData) => {
  try {
    const response = await api.post(endpoints.Address.AddUserAddress, addressData);
    return {
      data: response.data.data || null,
      status: response.data.status,
      statusCode: response.data.statusCode,
      message: response.data.message,
    };
  } catch (error) {
    console.error('Error adding user address:', error);
    return {
      data: null,
      status: false,
      statusCode: 500,
      message: error.response?.data?.message || 'Error adding address',
    };
  }
};

export const GetUserAddresses = async (userId) => {
  try {
    const response = await api.get(`${endpoints.Address.GetUserAddresses}?userId=${userId}`);
    return {
      data: response.data.data || [],
      status: response.data.status,
      statusCode: response.data.statusCode,
      message: response.data.message,
    };
  } catch (error) {
    console.error('Error getting user addresses:', error);
    return {
      data: [],
      status: false,
      statusCode: 500,
      message: 'Error getting addresses',
    };
  }
};

export const GetAllCities = async (params = {}) => {
  try {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`${endpoints.Address.GetAllCities}?${query}`);
    return {
      data: response.data?.data?.data || [],
      status: response.data?.status || false,
      statusCode: response.data?.statusCode || 500,
      message: response.data?.message || "",
    };
  } catch (error) {
    console.error('Error getting cities:', error);
    return {
      data: [],
      status: false,
      statusCode: 500,
      message: 'Error getting cities',
    };
  }
};

const addressService = {
  AddUserAddress,
  GetUserAddresses,
  GetAllCities
};

export default addressService;
